<template>
  <div class="space-list">
    <tab-module
      from="openSpaceList"
      :prop="tabattributes"
      :activeName="activeSpace"
      :totalNum="totalCount"
      @updateTeamSpaces="updateTeamSpaces"
    ></tab-module>
    <div
      id="DomPoint"
      class="div__item"
      v-if="activeSpace === '全部空间' && spaceLists.length"
    >
      <div
        class="space-block"
        @click="spaceBlock(item)"
        v-for="(item, index) in spaceLists"
        :key="index"
      >
        <div>
          <img
            v-if="item.coverUrl"
            class="space-avstar"
            :src="$hosts.static(item.coverUrl)"
            alt=""
          />
          <img
            v-else
            class="space-avstar"
            :src="require('@/assets/img/spaceBg.png')"
            alt=""
          />
        </div>
        <div class="space-text">
          <span
            :title="item.name"
            class="text-no-wrap"
            style="font-weight: bold; color: #495f70"
          >
            {{ item.name }}
          </span>
          <span
            class="space-name text-no-wrap"
            >所有者：{{ item.creatorName }}</span
          >
        </div>
      </div>
    </div>
    <div
      id="DomPoint"
      class="div__item"
      v-if="activeSpace === '我创建的' && spaceLists.length"
    >
      <div
        class="space-block"
        @click="spaceBlock(item)"
        v-for="(item, index) in spaceLists"
        :key="index"
      >
        <img
          v-if="item.coverUrl"
          class="space-avstar"
          :src="$hosts.static(item.coverUrl)"
          alt=""
        />
        <img
          v-else
          class="space-avstar"
          :src="require('@/assets/img/spaceBg.png')"
          alt=""
        />
        <div class="space-text">
          <span
            :title="item.name"
            class="text-no-wrap"
            style="font-weight: bold; color: #495f70"
          >
            {{ item.name }}
          </span>
          <span
            class="space-name text-no-wrap"
            >所有者：{{ item.creatorName }}</span
          >
        </div>
      </div>
    </div>
    <div
      id="DomPoint"
      class="div__item"
      v-if="activeSpace === '我参与的' && spaceLists.length"
    >
      <div
        class="space-block"
        @click="spaceBlock(item)"
        v-for="(item, index) in spaceLists"
        :key="index"
      >
        <img
          v-if="item.coverUrl"
          class="space-avstar"
          :src="$hosts.static(item.coverUrl)"
          alt=""
        />
        <img
          v-else
          class="space-avstar"
          :src="require('@/assets/img/spaceBg.png')"
          alt=""
        />
        <div class="space-text">
          <span
            :title="item.name"
            class="text-no-wrap"
            style="font-weight: bold; color: #495f70"
          >
            {{ item.name }}
          </span>
          <span
            class="space-name text-no-wrap"
            >所有者：{{ item.creatorName }}</span
          >
        </div>
      </div>
    </div>
    <span></span>
    <empty-content v-if="spaceLists.length === 0 && isDataAccomplish" />
  </div>
</template>

<script>
import TabModule from '@/components/layout/TabModule.vue'
import EmptyContent from '@/components/layout/EmptyContent'
export default {
  name: 'OpenSpaceList',
  components: {
    TabModule,
    EmptyContent,
  },
  data() {
    return {
      tabattributes: {
        box_style: 'width: 1216px;margin-top: 8px;margin: auto;',
        attr: {
          cur_tab_style: 'font-weight: 700;',
          cur_slide_style: '',
          tab_content: [
            {
              anchor_point: 'DomPoint',
            },
          ],
        },
      },
      spaceLists: [],
      activeSpace: '全部空间',
      isDataAccomplish: false, // 数据是否请求完成
      page_no: 1,
      page_size: 30,
      totalCount: 0,
      member_type: '',
      query: {},
      firstUse: true,
    }
  },
  created() {
    this.isDataAccomplish = false
    // 标识当前会话在打开云盘页面
    sessionStorage.setItem('inOpenFilePage', 'Y')
  },
  mounted() {
    this.firstUse = JSON.parse(localStorage.getItem('firstUse'))
    if (this.firstUse && this.spaceLists.length === 0) {
      this.activeSpace = '我创建的'
      this.$api.space.addTeamSpaces().then((res) => {
        if (res.data.code !== 'success') {
          // this.$message.error(`新建失败`)
        } else {
          if (res.data.data === 'success') {
            this.spaceLists = res.list
            // this.$message.success(`新建成功`)
            // 获取空间列表
            this.getTeamSpaces()
          } else {
            // this.$message.error(`该用户已经创建`)
          }
        }
      })
      localStorage.setItem('firstUse', 'false')
    } else {
      // 获取空间列表
      this.getTeamSpaces()
      // this.$tracks({ event: 'visitSpace' })
    }
  },
  methods: {
    updateTeamSpaces(index) {
      this.spaceLists = []
      this.page_no = 1
      this.isDataAccomplish = false
      this.getTeamSpaces(index)
    },
    // 获取空间列表
    getTeamSpaces(index) {
      if (
        this.spaceLists.length >= this.totalCount &&
        this.totalCount !== 0 &&
        index !== 'add'
      ) {
        return
      }
      if (index && index !== 'add') {
        this.page_no = index
      } else {
        this.page_no = 1
      }
      if (this.activeSpace === '全部空间') {
        this.query = {
          member_type: this.member_type,
          page_no: this.page_no,
          page_size: this.page_size,
        }
      }
      if (this.activeSpace === '我创建的') {
        this.query = {
          member_type: 'CREATOR',
          page_no: this.page_no,
          page_size: this.page_size,
        }
      }
      if (this.activeSpace === '我参与的') {
        this.query = {
          member_type: 'MEMBER',
          page_no: this.page_no,
          page_size: this.page_size,
        }
      }

      this.$api.space.getTeamSpaces(this.query).then((res) => {
        this.isDataAccomplish = true
        this.totalCount = res.totalCount
        if (this.query.page_no !== 1) {
          this.spaceLists = [...this.spaceLists, ...res.list]
        } else {
          this.spaceLists = res.list
        }
      })
    },
    // 进入空间
    spaceBlock(item) {
      this.$api.space.getSpacesDetail(item.id)
        .then((res) => {
          if (res.code === 'space.not.exists') {
            this.$message.error(`该空间不存在,请刷新界面！`)
          } else {
            sessionStorage.setItem('spaceName', item.name)
            this.$router.push({
              name: 'OpenFileList',
              params: { spaceId: item.id },
              query: { to: 'OpenSpaceList' }
            })
          }
        })
        .catch((error) => {
          console.error('获取空间详情时出错:', error)
          this.$message.error('获取空间详情失败，请刷新后重试')
        })
    },
    // Tab切换
    handleChildMessage(msg) {
      this.spaceLists = []
      this.page_no = 1
      this.activeSpace = msg
      this.isDataAccomplish = false
      this.getTeamSpaces()
    },
  },
}
</script>
<style lang="less" scoped>
.space-list {
  .div__item {
    width: 1200px;
    margin: auto auto 50px auto;
    //margin-bottom: 50px;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 16px;

    .space-block {
      width: 227.2px;
      height: 180px;
      border: 1px solid #d2d9e3;
      border-radius: 2px;
      cursor: pointer;
      box-shadow: none;
      .space-avstar {
        width: 225.2px;
        height: 122px;
        object-fit: cover;
        border-bottom: 1px solid #d2d9e3;
      }

      span {
        display: block;
        height: 20px;
        padding: 6px 0 0 10px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: left;
      }

      .space-name {
        font-size: 12px;
        color: @color-text-breadcrumb;
      }
    }
  }

  .platform-g {
    top: 54px !important;
  }

  .el-icon-refresh-right {
    color: #009ee1;
    padding-left: 6px;
    cursor: pointer;
  }

  .space-text {
    position: relative;
    top: -3px;
    height: 55px;
    cursor: pointer;
  }

  .space-block:hover {
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
    .space-name {
      color: #495f70 !important;
    }
  }
}
</style>
